var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764_5040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 1C11.3179 1 1 11.3179 1 24C1 36.6812 11.3179 47 24 47C36.6812 47 47 36.6812 47 24C47 11.3179 36.6831 1 24 1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0255 32.1888C27.9503 33.264 25.6465 33.6478 24.0047 33.6478C22.3582 33.6478 20.0592 33.264 18.984 32.1888C18.7295 31.9343 18.3215 31.9343 18.0674 32.1888C17.8128 32.4434 17.8128 32.8513 18.0674 33.1055C19.7713 34.8094 23.0449 34.9438 24.0047 34.9438C24.9646 34.9438 28.2334 34.8094 29.9425 33.1055C30.1919 32.851 30.1919 32.443 29.9425 32.1888C29.688 31.9343 29.28 31.9343 29.0255 32.1888Z",
    fill: "#FD471E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 26.5009C20.9998 25.1232 19.8766 24 18.4989 24C17.1216 24 15.998 25.1232 15.998 26.5009C15.998 27.8782 17.1216 29.0017 18.4989 29.0017C19.8766 29.0017 20.9998 27.8785 20.9998 26.5009Z",
    fill: "#FD471E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7472 0 0 10.7472 0 24C0 37.2528 10.7472 48 24 48C37.2528 48 48 37.2528 48 24C48 10.7472 37.2528 0 24 0ZM37.9248 27.2014C37.9775 27.5471 38.0065 27.8976 38.0065 28.2528C38.0065 33.6383 31.7377 38.0017 24.0048 38.0017C16.2719 38.0017 10.0031 33.6383 10.0031 28.2528C10.0031 27.8928 10.032 27.5376 10.0847 27.1919C8.8656 26.6448 8.01599 25.4209 8.01599 24C8.01599 22.0704 9.58081 20.5009 11.5151 20.5009C12.4559 20.5009 13.3055 20.8704 13.9343 21.4753C16.363 19.7234 19.7234 18.6046 23.4624 18.5087C23.4624 18.4607 25.2096 10.1375 25.2096 10.1375C25.2433 9.97449 25.3392 9.83496 25.4784 9.74414C25.6176 9.65295 25.7856 9.62402 25.949 9.65771L31.7666 10.8959C32.1746 10.0704 33.0143 9.49915 33.9983 9.49915C35.3807 9.49915 36.4991 10.6176 36.4991 12C36.4991 13.3824 35.3807 14.5009 33.9983 14.5009C32.6591 14.5009 31.5743 13.4447 31.5121 12.1201L26.3038 11.0112L24.7104 18.5138C28.3824 18.6431 31.6802 19.7567 34.0704 21.4849C34.6992 20.8755 35.5536 20.5009 36.4991 20.5009C38.4338 20.5009 39.9983 22.0657 39.9983 24C39.9983 25.4304 39.1392 26.6543 37.9248 27.2014Z",
    fill: "#FD471E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5009 24C28.1232 24 27 25.1232 27 26.5009C27 27.8782 28.1232 29.0017 29.5009 29.0017C30.8782 29.0017 32.0017 27.8782 32.0017 26.5009C32.0017 25.1232 30.8785 24 29.5009 24Z",
    fill: "#FD471E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_764_5040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.a3a730116446499ba4339377be6437dd.svg";
export { ForwardRef as ReactComponent };